// extracted by mini-css-extract-plugin
export default {"header2":"Header2_header2__eKuKF"};